/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"

function Line(props) {
  return (
    <div
      sx={{
        height: 0,
        borderWidth: "1px",
        borderColor: "white",
        borderStyle: "solid",
        opacity: 0.12,
        width: "100%",
      }}
      {...props}
    />
  )
}
export { Line }
